export const useLogout = () => {
  /**
   * V2 should orchestrate the logout process
   * so we dispatch an event to notify the V2 code
   * to trigger logout function in Context.ts. In its
   * turn, Context.ts will dispatch the 'cp-ui-v3-logout'
   * event to notify the V3 code to initiate cleanup.
   *
   * This is a temporary solution until we fully migrate to V3.
   */
  return () => document.dispatchEvent(new CustomEvent('cp-ui-v2-logout'));
};
